var scope_0 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6163b1fcea13c51654f8c9e39a847844.js').default;
var scope_1 = require('/vercel/path2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ddd8040744534c40fd03585ff4802374.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    